import { connect } from 'react-redux';
import { get } from 'lodash';

import BopBasicInfo from '../components/partials/BopBasicInfo';
import { isUserLoggedIn } from 'apps/user/helpers';
import { addToFavourites, removeFromFavourites } from 'apps/favourites/actions/favourites';
import { openShoppingListsModal } from 'apps/shoppingLists/actions/shoppingLists';
import { BetaFeatures as FoodProfileBetaFeatures } from 'apps/foodProfile/consts';

export default connect((state, ownProps) => {
  const { user, externalisedStrings, properties: { usePredefinedLabelForEDLP } } = state;
  const betaFeatures = user.betaFeatures || [];
  const showZerosAfterPounds = !betaFeatures.includes('CUT_ZEROS_IN_FOP_ROUND_POUND');
  const isFoodMaestroEnabled = betaFeatures.includes(FoodProfileBetaFeatures.FOODMAESTRO_ENABLED);
  const moreExclusiveOffer = {
    isMoreCardCustomer: get(user, 'customerDetails.isMoreCardCustomer', false),
    moreOffersUrl: get(externalisedStrings, 'accountSettings.PREFERENCES.moreOffersUrl', ''),

  };

  return {
    ...ownProps,
    basketItems: state.basket.items,
    deliverySlot: state.deliverySlot,
    isFoodMaestroEnabled,
    isLoggedIn: isUserLoggedIn(user),
    productWarnings: state.basket.productWarnings,
    showRegulars: user.features.includes('SUBSCRIPTIONS'),
    showZerosAfterPounds,
    usePredefinedLabelForEDLP,
    moreExclusiveOffer,
  };
}, {
  addToFavourites,
  removeFromFavourites,
  openShoppingListsModal,
})(BopBasicInfo);
